const shapeTypes = {
  Circle: {
    viewBox: "0 0 80 80",
    // width: "80",
    // height: "80",
    preserveAspectRatio: "meet",
    id: "circle",
    cx: "40",
    cy: "40",
    r: "38",
  },
  ArrowCommon: {
    basic: {
      viewBox: "0 0 80 80",
      // width: "80",
      // height: "80",
      preserveAspectRatio: "none",
      id: "arrowCommon",
      d: "80 40 28 9 28 26 0 26 0 54 28 54 28 71 80 40",
    },
    alternative: {
      viewBox: "0 0 80 80",
      // width: "80",
      // height: "80",
      preserveAspectRatio: "none",
      id: "arrowCommon90",
      d: "40 80 71 28 54 28 54 0 26 0 26 28 9 28 40 80",
    },
  },
  ArrowThin: {
    basic: {
      viewBox: "0 0 20 80",
      // width: "20",
      // height: "80",
      preserveAspectRatio: "meet",
      id: "arrowThin",
      d: "M0 0L20 40L0 80V0Z",
    },
    alternative: {
      viewBox: "0 0 80 20",
      // width: "80",
      // height: "20",
      preserveAspectRatio: "meet",
      id: "arrowThin90",
      d: "M0 10L80 10L40 20Z",
    },
  },
  ArrowFull: {
    basic: {
      viewBox: "0 0 84 70",
      // width: "84",
      // height: "70",
      preserveAspectRatio: "none",
      id: "arrowFull",
      d: "M0 0H68L80 35L68 70H0V0Z",
    },
    alternative: {
      viewBox: "0 0 70 84",
      // width: "70",
      // height: "84",
      preserveAspectRatio: "none",
      id: "arrowFull90",
      d: "M0 0V68L35 80L70 68V0H0Z",
    },
  },
  RoundedThinRectangle: {
    basic: {
      viewBox: "0 0 100 60",
      // width: "100",
      // height: "60",
      id: "roundedThinRectangle",
      preserveAspectRatio: "none",
      x: "0",
      y: "15",
      rectWidth: "100",
      rectHeight: "30",
      rx: 20,
      ry: 20,
    },
    alternative: {
      viewBox: "0 0 60 100",
      // width: "60",
      // height: "100",
      id: "roundedThinRectangle90",
      preserveAspectRatio: "none",
      x: "15",
      y: "0",
      rectWidth: "30",
      rectHeight: "100",
      rx: 20,
      ry: 20,
    },
  },
  ArrowWithoutTail: {
    basic: {
      viewBox: "0 0 35 80",
      // width: "35",
      // height: "80",
      preserveAspectRatio: "meet",
      id: "arrowWithoutTail",
      d: "M0 0L10 0L35 40L10 80L0 80L25 40L0 0Z",
    },
    alternative: {
      viewBox: "0 0 80 60",
      // width: "80",
      // height: "60",
      preserveAspectRatio: "meet",
      id: "arrowWithoutTail90",
      d: "M0 25L0 35L40 60L80 35L80 25L40 50L0 25Z",
    },
  },
  Oval: {
    viewBox: "0 0 100 60",
    // width: "100",
    // height: "60",
    preserveAspectRatio: "none",
    id: "oval",
    cx: "50",
    cy: "30",
    rx: "50",
    ry: "30",
  },
  Quarter: {
    basic: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "quarter",
      d: "M 50 50 L 50 0 A 50 50 0 0 1 100 50 Z",
    },
    alternative: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "quarter90",
      d: "M 50 50 L 100 50 A 50 50 0 0 1 50 100 Z",
    },
  },
  CurvedArrow: {
    basic: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "curvedArrow",
      d: "M 55 100 L 45 100 A 55 55 0 0 1 90 45 L 90 40 L 100 50 L 90 60 L 90 55 A 45 45 0 0 0 55 100 Z",
    },
    alternative: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "curvedArrow90",
      d: "M 0 55 L 0 45 A 55 55 0 0 1 55 90 L 40 90 L 50 100 L 60 90 L 45 90 A 45 45 0 0 0 0 55 Z",
    },
  },
  Triangle: {
    basic: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "triangle",
      d: "M 50 10 L 60.625 90 H 39.375 Z",
    },
    alternative: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "triangle90",
      d: "M 100 50 L 10 60.625 V 39.375 Z",
    },
  },
  Trapeze1: {
    basic: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "trapeze1",
      d: "M 36.875 10 L 63.125 10 L 73.75 90 H 26.25 Z",
    },
    alternative: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "trapeze190",
      d: "M 90 36.875 L 90 63.125 L 10 73.75 V 26.25 Z",
    },
  },
  Trapeze2: {
    basic: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "trapeze2",
      d: "M 23.75 10 L 76.75 10 L 86.875 90 H 13.125 Z",
    },
    alternative: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "trapeze290",
      d: "M 90 23.75 L 90 76.75 L 10 86.875 V 13.125 Z",
    },
  },
  Trapeze3: {
    basic: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "trapeze3",
      d: "M 10.625 10 L 89.375 10 L 100 90 H 0 Z",
    },
    alternative: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "trapeze390",
      d: "M 90 10.625 L 90 89.375 L 10 100 V 0 Z",
    },
  },
  LongTriangle: {
    basic: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "longTriangle",
      d: "M 50 2 L 100 98 H 0 z",
    },
    alternative: {
      viewBox: "0 0 100 100",
      // width: "100",
      // height: "100",
      preserveAspectRatio: "none",
      id: "longTriangle90",
      d: "M 100 50 L 0 100 V 0 Z",
    },
  },
};

export function isSimpleShape(type) {
  return type === "Circle" || type === "Oval";
}

export function getShapeProperties(type, needsSpecialRotation) {
  const shapeConfig = shapeTypes[type];
  if (!shapeConfig) return null;

  if (isSimpleShape(type)) {
    return shapeConfig;
  }

  return shapeConfig[needsSpecialRotation ? "alternative" : "basic"];
}
